import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { signOut as signOutAction } from "../../actions/loginActions";
import { clearMailData as clearMailDataAction } from "../../actions/mailActions";
import UserSettings from '../settings/model/Settings';
import Settings from '../settings/Settings';

interface IHeaderProps {
  isAuthenticated: boolean;
  settings: UserSettings;
  user: string;
  clearMailData: () => any;
  signOut: () => any;
}

interface IHeaderState {
  isSettingsOpen: boolean;
}

export class Header extends React.Component<IHeaderProps, IHeaderState> {

  constructor(props: IHeaderProps) {
    super(props);
    this.state = { isSettingsOpen: false };
    this.handleSignOut = this.handleSignOut.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  public async handleSignOut() {
    await this.props.signOut();
    await this.props.clearMailData();
  }

  public toggle() {
    this.setState({
      isSettingsOpen: !this.state.isSettingsOpen
    });
  }

  public render() {
    const authenticatedOptions = (<div className="col-6 nav-ftns inline">
      <span className="navbar-user">{this.getDisplayEmail()}</span>
      <a href="" onClick={this.handleSignOut}>
        <FormattedMessage id="L.Logout" defaultMessage="Logout" />
        <i className="material-icons">exit_to_app</i>
      </a>
      <button className="navbar-toggler" type="button" onClick={this.toggle}>
        <i className="material-icons">settings</i>
      </button>
    </div>);

    return (
      <div className="pos-f-t">
        {this.props.isAuthenticated && <Settings isOpen={this.state.isSettingsOpen} />}
        {this.props.isAuthenticated && <nav className="row justify-content-between navbar navbar-light">
          <h4 className="col-6 pl-0 inline">
            <FormattedMessage id="L.Title" defaultMessage="Quarantine Manager" />
          </h4>
          {authenticatedOptions}
        </nav>}
      </div>
    );
  }

  private getDisplayEmail() {
    const user = this.props.user;
    if (!user) {
      return '';
    }
    const emailComponents = user.split('@');
    if (emailComponents[1] === 'quarantine.emailsrvr.com') {
      return emailComponents[0];
    }
    return user;
  }
}

const mapStateToProps = (state: any) => {
  return {
    isAuthenticated: state.authentication.isAuthenticated,
    settings: state.settings.settings,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    clearMailData: bindActionCreators(clearMailDataAction, dispatch),
    signOut: bindActionCreators(signOutAction, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/layout/Header.tsx